module.exports = __webpack_public_path__ + "img/add.60e60ba3.svg";